<script>
	import Ban from "./Ban.svelte";
	import Bin from "./Bin.svelte";
	import Bell from "./Bell.svelte";
	import Bookmark from "./Bookmark.svelte";
	import Calendar from "./Calendar.svelte";
	import Chat from "./Chat.svelte";
	import ChevronDown from "./ChevronDown.svelte";
	import ChevronUp from "./ChevronUp.svelte";
	import ChevronUpDown from "./ChevronUpDown.svelte";
	import Click from "./Click.svelte";
	import Clock from "./Clock.svelte";
	import Cog from "./Cog.svelte";
	import Copy from "./Copy.svelte";
	import Divide from "./Divide.svelte";
	import Info from "./Info.svelte";
	import Link from "./Link.svelte";
	import Lock from "./Lock.svelte";
	import Login from "./Login.svelte";
	import Logout from "./Logout.svelte";
	import No from "./No.svelte";
	import Page from "./Page.svelte";
	import PaintBrush from "./PaintBrush.svelte";
	import PencilSquare from "./PencilSquare.svelte";
	import Plus from "./Plus.svelte";
	import QuestionMarkCircle from "./QuestionMarkCircle.svelte";
	import Quote from "./Quote.svelte";
	import Revert from "./Revert.svelte";
	import Save from "./Save.svelte";
	import Star from "./Star.svelte";
	import ThumbsUp from "./ThumbsUp.svelte";
	import TableCell from "./TableCell.svelte";
	import Tick from "./Tick.svelte";
	import Undo from "./Undo.svelte";
	import User from "./User.svelte";
	import UserCircle from "./UserCircle.svelte";
	import Users from "./Users.svelte";
	import X from "./X.svelte";

	export let name;

	$: Icon = {
		ban: Ban,
		bin: Bin,
		bell: Bell,
		bookmark: Bookmark,
		calendar: Calendar,
		chat: Chat,
		chevronDown: ChevronDown,
		chevronUp: ChevronUp,
		chevronUpDown: ChevronUpDown,
		click: Click,
		clock: Clock,
		cog: Cog,
		copy: Copy,
		divide: Divide,
		info: Info,
		link: Link,
		lock: Lock,
		login: Login,
		logout: Logout,
		no: No,
		page: Page,
		paintBrush: PaintBrush,
		pencilSquare: PencilSquare,
		plus: Plus,
		questionMarkCircle: QuestionMarkCircle,
		quote: Quote,
		revert: Revert,
		save: Save,
		star: Star,
		thumbsUp: ThumbsUp,
		tableCell: TableCell,
		tick: Tick,
		undo: Undo,
		user: User,
		userCircle: UserCircle,
		users: Users,
		x: X,
	}[name];
</script>

<svelte:component this={Icon} />
